<!--
  Campo a tendina con etichetta: il nome del campo resta scritto sopra, anche
  dopo aver scelto un valore (il placeholder sparirebbe).

  Il pulsante «+» sta accanto al campo e non sotto l'etichetta: è un'azione
  sul campo, non un altro campo.
-->
<template>
  <div class="sel">
    <span
      v-if="title"
      class="sel__label"
    >{{ title }}</span>

    <div class="sel__row">
      <el-cascader
        v-model="selectedElement"
        class="sel__input"
        :class="{ highlight: highlight }"
        placeholder="Seleziona"
        :options="options"
        filterable
        clearable
        :prop="prop"
      />

      <router-link
        v-if="addButtom"
        class="routerLink sel__add"
        :to="{ path: linkPath }"
      >
        <el-button
          :disabled="isDisabled"
          :title="`Aggiungi`"
        >
          <el-icon :size="18">
            <CirclePlus />
          </el-icon>
        </el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    addButtom: {
      type: Boolean,
      require: true,
    },
    highlight: {
      type: Boolean,
      require: true,
    },
    linkPath: {
      type: String,
      required: false,
    },
    model: {
      required: false,
    },
    isDisabled: {
      type: Boolean,
      require: true,
    },
    span: {
      type: Number,
      required: false,
      default: 8,
    },
    style: {
      type: String,
      required: false,
    },

    prop: {
      type: String,
      required: false,
    },

    value: {
      required: false,
    },
  },

  data() {
    return {
      //selectedElement: '',
      selectedElement: this.value,
    };
  },

  watch: {
    value(newValue) {
      this.selectedElement = newValue;
    },

    selectedElement(newValue) {
      this.$emit('selected', newValue);
    },
  },
};
</script>

<style scoped>
.sel {
  display: flex;
  flex-direction: column;
  gap: 5px;
  text-align: left;
  min-width: 0;
}

.sel__label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--color-text-secondary, #737373);
}

.sel__row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.sel__input {
  flex: 1;
  min-width: 0;
}

.sel__add {
  flex: none;
}

/* Campo in errore: Element disegna il bordo con una `box-shadow` sul wrapper
   INTERNO, quindi si cambia il colore di quell'anello invece di aggiungere un
   bordo (che sfalserebbe il campo rispetto ai vicini). `:deep()` perché
   `.el-input__wrapper` è interno al componente Element. */
.highlight :deep(.el-input__wrapper) {
  box-shadow: 0 0 0 1px var(--color-danger, #EF4444) inset !important;
}
</style>
